import { useSelector } from "react-redux";
import { Layout } from "../layout/Layout";
import { Box } from "@mui/material";
import LottieAnimation from "../../animation/LottieAnimation";

export const withSessionCheck = (
  Component,
  allowedSessionTypes,
  WrapperComponent = null,
  wrapperProps = {},
  useLayout = true,
  layoutProps = {},
) => {
  return function ProtectedRouteComponent() {
    const sessions = useSelector((state) => state.sessions);
    const currentSessionType = sessions.currentSession;
    const isForcedLogout = sessions?.sessionForcedLogout;

    const isSessionValid =
      !isForcedLogout &&
      sessions[sessions.currentSession]?.token &&
      sessions[sessions.currentSession]?.isValidated &&
      allowedSessionTypes.includes(currentSessionType);

    const loadingFallback = (
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <>
          <Box sx={{ mb: 2 }}>
            <img
              style={{
                width: "10rem",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              alt="Permit Rockstar Logo"
              src="/img/logos/logo_main.png"
            />
          </Box>
          <LottieAnimation />
        </>
      </Box>
    );

    if (isForcedLogout) {
      return useLayout ? <Layout {...layoutProps} /> : null;
    }

    if (!isSessionValid) {
      return useLayout ? (
        <Layout {...layoutProps}>{loadingFallback}</Layout>
      ) : (
        loadingFallback
      );
    }

    const resolvedWrapperProps =
      typeof wrapperProps === "function" ? wrapperProps() : wrapperProps;

    const ComponentToRender = WrapperComponent ? (
      <WrapperComponent {...resolvedWrapperProps}>
        <Component />
      </WrapperComponent>
    ) : (
      <Component />
    );

    return useLayout ? (
      <Layout {...layoutProps}>{ComponentToRender}</Layout>
    ) : (
      ComponentToRender
    );
  };
};
